import { Injectable } from '@angular/core';
import { ContratInformations, GetPolicesResponse, Police2 } from '../MIF.Subscription.Parrot';
import { ParrotService } from './parrot.service';

@Injectable({
  providedIn: 'root'
})
export class WsGetPolices {
  constructor(private parrotService: ParrotService) {}

  public async getPolices(): Promise<GetPolicesResponse> {
    const statePolicies = await this.parrotService.getPolicies();

    return new GetPolicesResponse({
      police: new Police2({
        contratInformations: this.mapContratInformations(statePolicies ?? [])
      })
    });
  }

  private mapContratInformations(
    statePolicies: Array<{ productCode?: string | null; stateId?: number }> = []
  ): ContratInformations[] {
    return statePolicies.map(statePolicy => {
      return new ContratInformations({
        codeProduit: statePolicy?.productCode ?? undefined,
        idEtat: statePolicy?.stateId
      });
    });
  }
}
